export default __webpack_public_path__ + "static/media/create_manage_orders.f18b0d36.png";